import type { LitElement } from "lit";
import globalStyleSheetRaw from "#app/styles/index.css?inline";
import { assert } from "#core/utils/assert.ts";

// TODO replace with import attributes once FF147 is shipped
const globalStyleSheet = (() => {
  const stylesheet = new CSSStyleSheet();

  stylesheet.replaceSync(globalStyleSheetRaw);

  return stylesheet;
})();

type Constructor<T = unknown> = new (
  // biome-ignore lint/suspicious/noExplicitAny: using `unknown` triggers TS2545, see <https://github.com/microsoft/TypeScript/issues/37142>
  ...args: any[]
) => T;

export const WithGlobalStylesheet = <T extends Constructor<LitElement>>(
  el: T,
) =>
  class extends el {
    override createRenderRoot(): HTMLElement | DocumentFragment {
      const root = super.createRenderRoot();

      assert(root instanceof ShadowRoot, "render root must be a shadow root");

      root.adoptedStyleSheets = [globalStyleSheet, ...root.adoptedStyleSheets];

      return root;
    }
  } as T;
